import {
  // @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
  jsx as _jsx,
  // @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
  Fragment as _Fragment,
  // @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
  jsxs as _jsxs,
} from "react/jsx-runtime"
import { useEffect, useState } from "react"
import { Skeleton } from "primereact/skeleton"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Dropdown } from "primereact/dropdown"

const Table = ({
  columns = [],
  value = [],
  className,
  selectionMode,
  selected,
  onSelectionChange,
  removableSort,
  sortField,
  sortOrder,
  onSort,
  onPage,
  paginator,
  showSelectionElement,
  totalRecords,
  first,
  rows,
  rowsPerPageOptions,
  multiple,
  header,
  onRowClick,
  onRowSelect,
  expandedRows,
  rowExpansionTemplate,
  globalFilter,
  filterDelay,
  dtRef,
  lazy = true,
  filters,
  setFilters,
  reorderableColumns,
  resizableColumns,
  onColReorder,
  onColumnResizeEnd,
  onChangeRowsPerPage,
  scrollable,
  frozenWidth,
  scrollHeight,
  stateKey,
  isLoading,
  virtualScroll = false,
  virtualRowHeight,
  onVirtualScroll,
  emptyMessage = "",
  virtualScrollDelay = 250,
  onRowUnselect,
  skeletonLoader,
  dataKey,
  editMode,
  editingRows,
  rowEditorValidator,
  onRowEditInit,
  onRowEditSave,
  onRowEditCancel,
  onRowEditChange
}: any) => {
  const loadingBody = () => {
    return _jsx(Skeleton, {}, void 0)
  }
  // @ts-expect-error TS(7006): Parameter 'col' implicitly has an 'any' type.
  const dynamicColumns = columns.map((col) => {
    const textAlignStyle = { textAlign: col.textAlign || "left" }
    return col.isFunctionComponent
      ? _jsx(
          Column,
          {
            headerStyle:
              scrollable && !col.frozen
                ? { ...textAlignStyle, width: "180px" }
                : textAlignStyle,
            ...col,
            body: (e: any) => (isLoading && virtualScroll) || (isLoading && skeletonLoader)
              ? _jsx(Skeleton, {}, void 0)
              : _jsx(col.body, { rowData: e }, void 0),
            loadingBody,
          },
          void 0
        )
      : _jsx(
          Column,
          {
            headerStyle:
              scrollable && !col.frozen
                ? { ...textAlignStyle, width: "180px" }
                : textAlignStyle,
            ...col,
            body: (e: any) => (isLoading && virtualScroll) || (isLoading && skeletonLoader)
              ? _jsx(Skeleton, {}, void 0)
              : col.body
              ? col.body(e)
              : col.field
              ? e[col.field]
              : "",
            loadingBody,
          },
          void 0
        );
  })
  const [definitiveRows, setDefinitiveRows] = useState(rowsPerPageOptions || [])
  useEffect(() => {
    if (rowsPerPageOptions && totalRecords) {
      const resRow = rowsPerPageOptions.filter(
        (rowPerPage: any) => rowPerPage < totalRecords
      )
      if (totalRecords < rowsPerPageOptions[rowsPerPageOptions.length - 1]) {
        resRow.push(totalRecords)
      }
      setDefinitiveRows(resRow)
    }
  }, [rowsPerPageOptions, totalRecords])
  const greater =
    rows && totalRecords && rows > totalRecords ? totalRecords : rows
  const isLoadingWithSekeletonMode = isLoading && skeletonLoader
  return _jsx(
    "div",
    {
      className: `g-data-table__containter${className ? ` ${className}` : ""}${
        skeletonLoader ? " skeletonLoadingMode" : ""
      }`,
      children: _jsxs(
        DataTable,
        {
          loading: isLoading && !virtualScroll,
          ref: dtRef,
          lazy,
          stateKey,
          globalFilter,
          filterDelay,
          filters,
          onFilter: (e: any) => {
            setFilters && setFilters(e.filters)
          },
          paginator: !isLoadingWithSekeletonMode ? paginator : undefined,
          totalRecords,
          first,
          removableSort,
          selection: selected,
          onSelectionChange,
          selectionMode,
          currentPageReportTemplate: "{first} - {last} de {totalRecords}",
          paginatorTemplate: {
            layout:
              "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
            FirstPageLink: null,
            PrevPageLink: null,
            PageLinks: null,
            NextPageLink: null,
            LastPageLink: null,
            RowsPerPageDropdown: (options: any) => {
              return _jsxs(
                _Fragment,
                {
                  children: [
                    _jsx(
                      "span",
                      { children: " Filas por p\u00E1gina" },
                      void 0
                    ),
                    _jsx(
                      Dropdown,
                      {
                        value: options.value,
                        onChange: (e: any) => {
                          if (onChangeRowsPerPage) {
                            onChangeRowsPerPage(e.value)
                          }
                        },
                        options: options.options,
                        className: "g-rows-per-page__dropdown",
                      },
                      void 0
                    ),
                  ],
                },
                void 0
              );
            },
            CurrentPageReport: null,
          },
          rows: greater,
          rowsPerPageOptions: definitiveRows,
          showSelectionElement,
          onPage,
          className: "p-datatable-striped p-datatable-responsive",
          value,
          sortField,
          sortOrder,
          onSort,
          header,
          onRowClick,
          onRowUnselect,
          onRowSelect,
          expandedRows,
          rowExpansionTemplate,
          reorderableColumns,
          resizableColumns,
          onColReorder,
          onColumnResizeEnd,
          emptyMessage,
          scrollable,
          scrollHeight,
          virtualScroll,
          virtualRowHeight,
          onVirtualScroll,
          virtualScrollDelay,
          frozenWidth: !virtualScroll ? frozenWidth : "",
          dataKey,
          editMode,
          editingRows,
          rowEditorValidator,
          onRowEditInit,
          onRowEditSave,
          onRowEditCancel,
          onRowEditChange,
          children: [
            multiple &&
              _jsx(
                Column,
                {
                  selectionMode: isLoadingWithSekeletonMode
                    ? undefined
                    : "multiple",
                  headerStyle: { width: "3em" },
                  frozen: !!frozenWidth && !virtualScroll,
                  loadingBody,
                  body: isLoadingWithSekeletonMode ? loadingBody : null,
                },
                void 0
              ),
            dynamicColumns,
          ],
        },
        void 0
      ),
    },
    void 0
  );
}
export default Table
